import { ROUTES } from '@/config/routeConfig';
import {
  getTabSlug,
  AccountDetailsTab,
} from '@/shared/config/account-details-tabs';

export function getAccountDetailsPath(
  organizationId: string,
  tab?: AccountDetailsTab | undefined,
): string {
  return ROUTES.ACCOUNT_DETAILS_TAB
    .replace(':organizationId', organizationId)
    .replace(':tabSlug', getTabSlug(tab));
}